import { Backdrop, Box, CircularProgress, Typography } from "@mui/material";
import { useTranslation } from "react-i18next";

type LoadingBackDropProps = {
  open: boolean;
  message: string;
};

export default function LoadingBackDrop({
  open,
  message,
}: LoadingBackDropProps) {
  const { t } = useTranslation();
  return (
    <Backdrop open={open} sx={{zIndex : 9999}}>
      <Box display="flex" flexDirection={"column"}>
        <Box sx={{ textAlign: "center" }}>
          <CircularProgress color="primary" size={65} />
        </Box>
        <Box sx={{ textAlign: "center" }}>
          {message && <Typography>{t(message)}</Typography>}
        </Box>
      </Box>
    </Backdrop>
  );
}
